import Reveal from "./Reveal";

const ITEMS = [
  {
    title: "app EscapeFlow (acesso antecipado)",
    body: "o app que sustenta tudo. tá em beta e evolui toda semana. tu entra agora e vê ele crescer na tua frente.",
  },
  {
    title: "check-in diário de 4 hábitos",
    body: "sem meta mínima. tu faz e marca. o ritual completo tu vê logo abaixo.",
  },
  {
    title: "grupo exclusivo no whatsapp",
    body: "é onde tudo acontece. a galera se conecta, se cobra, e eu ali dentro todo dia.",
  },
  {
    title: "1 a 2 aulas ao vivo comigo",
    body: "ao vivo, durante o desafio. a data eu solto no grupo.",
  },
];

const Included = () => (
  <section className="px-6 py-20 sm:py-28">
    <div className="mx-auto max-w-4xl">
      <Reveal>
        <h2 className="text-center text-3xl font-extrabold tracking-[-0.03em] sm:text-5xl">
          o que tá incluso
        </h2>
      </Reveal>
      <div className="mt-12 grid gap-4 sm:grid-cols-2 sm:gap-5">
        {ITEMS.map((item, i) => (
          <Reveal key={item.title} delay={i * 90}>
            <div className="h-full rounded-2xl border border-black/10 p-6 transition-all duration-300 hover:-translate-y-1 hover:border-black/30 hover:shadow-lg sm:p-8">
              <span className="flex h-9 w-9 items-center justify-center rounded-full border border-black text-sm font-bold">
                {i + 1}
              </span>
              <h3 className="mt-5 text-lg font-bold tracking-[-0.02em] sm:text-xl">
                {item.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-black/60 sm:text-base">
                {item.body}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Included;
